import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  margRight: {
    paddingRight: 144,
    [theme.breakpoints.down('md')]: {
      paddingRight: 100,
    },
  },
  marginBot: {
    marginBottom: theme.spacing(1),
  },
  container: {
    padding: theme.spacing(1),
  },
  icon: {
    height: theme.spacing(2),
    width: theme.spacing(2),
    verticalAlign: 'text-bottom',
    marginRight: theme.spacing(0.5),
  },
  displayScores: {
    display: 'flex',
    [theme.breakpoints.down('xl')]: {
      flexDirection: 'column',
    },
  },
  button: {
    color: theme.palette.text.primary,
  },
  hideXSmall: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'inherit',
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  padLeft: {
    paddingLeft: theme.spacing(1),
  },
}));

export default useStyles;
